// extracted by mini-css-extract-plugin
module.exports = {"ReadonlyLabel":"ReadonlyLabel_ReadonlyLabel__1un4d"};